import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { GetStatusUsageResult } from './get-status-usage.result';

@Injectable({ providedIn: 'root' })
export class GetStatusUsageUseCase {
  private readonly repository = inject(StatusRepository);

  execute(id: string): Observable<GetStatusUsageResult> {
    return this.repository.getStatusUsage(id).pipe(
      map((usage) => ({
        caseTypes: usage.assignedTypes,
        usedByRecordCount: usage.usedByRecordCount,
      })),
    );
  }
}
